<template>
  <div :id="modalId ? modalId : 'modal-fail'" class="modal fade">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">글이 저장되지 않았습니다</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="modal-body">
            <span v-html="messageHtml"></span>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" data-dismiss="modal">닫기</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UpdateErrorModal',
  props: ['messageHtml', 'modalId'],
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped></style>
